"use client";

import { useEffect } from "react";
import Link from "next/link";

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    console.error(error);
  }, [error]);

  return (
    <div className="min-h-[70vh] flex flex-col items-center justify-center gap-5 px-6 text-center">
      <h1 className="text-2xl font-semibold text-gray-900 dark:text-white">
        Something went wrong
      </h1>
      <p className="max-w-md text-sm text-gray-600 dark:text-gray-400">
        An unexpected error occurred while loading this page. You can try again,
        or head back home.
      </p>
      <div className="flex gap-3">
        <button
          onClick={reset}
          className="rounded-lg bg-gray-900 dark:bg-white text-white dark:text-gray-900 px-5 py-2 text-sm font-medium"
        >
          Try again
        </button>
        <Link
          href="/"
          className="rounded-lg border border-gray-300 dark:border-white/20 px-5 py-2 text-sm hover:bg-gray-100 dark:hover:bg-white/10"
        >
          Go home
        </Link>
      </div>
    </div>
  );
}
